<ng-container *ngIf="selectedCompetency">
  {{ selectedCompetency.title | truncatePhrase : 22 }}
</ng-container>
